import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select } from 'antd';
import { useNavigate, useSearchParams } from "react-router";
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import ProductService from 'services/product';
import TagsPicker from "components/pickers/product_tag"
import CategoryPicker from "components/pickers/product_category"
import _ from "lodash"
const { Search } = Input;
const service = new ProductService();


const ProductList = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);

  let [searchParams, setSearchParams] = useSearchParams();
  const getCurrentSearParams = () => {
    const params = JSON.parse(searchParams.get("q")) ?? {};
    if (!params.status) {
      params.status = "all"
    }

    if (!params.stock) {
      params.stock = "all"
    }

    return params;
  }
  var searchPr = getCurrentSearParams();
  const [filter, setFilter] = useState(searchPr)
  useEffect(() => {
    // delaySearch(filter);
    if (!_.isEqual(searchPr, filter)) {
      setFilter(searchPr)
    }
  }, [])

  useEffect(() => {
    delaySearch(filter);
    var searchPr = getCurrentSearParams();

    if (!_.isEqual(searchPr, filter)) {
      setSearchParams({ q: JSON.stringify(filter) })
    }

  }, [filter])

  const onSearch = async (data) => {
    var postData = {...data, info: data?.info };
    if (data?.status == "show") {
      postData.hide = false;
    }
    if (data?.status == "hide") {
      postData.hide = true;
    }


    if (data?.stock == "in_stock") {
      postData.out_of_stock = false;
    }

    if (data?.stock == "out_of_stock") {
      postData.out_of_stock = true;
    }


    var list = await service.list(postData);
    setData(list);
  }


  const delaySearch = useMemo(() => _.debounce(onSearch, 500, { leading: false }), []);

  const onSearchChange = (e, value) => {
    delaySearch(e.target.value)
  }

  const setFilterValue = (name, value) => {

    var newFilter = { ...filter };
    newFilter[name] = value;
    setFilter(newFilter)
  }

  const loadData = async () => {
    var list = await service.list();
    setData(list);
  }
  // const data = [
  //   {
  //     key: '1',
  //     name: 'John Brown',
  //     age: 32,
  //     address: 'New York No. 1 Lake Park',
  //     tags: ['nice', 'developer'],
  //   },
  //   {
  //     key: '2',
  //     name: 'Jim Green',
  //     age: 42,
  //     address: 'London No. 1 Lake Park',
  //     tags: ['loser'],
  //   },
  //   {
  //     key: '3',
  //     name: 'Joe Black',
  //     age: 32,
  //     address: 'Sydney No. 1 Lake Park',
  //     tags: ['cool', 'teacher'],
  //   },
  // ];

  const columns = [

    {
      title: 'Sản phẩm',
      render: (_, record) => {
        return (
          <div>
            <Space>
              <Image width={75} src={record.thumbnail.url} />
              <div>
                {record.name}
              </div>
            </Space>
          </div>

        )
      }
    },

    {
      title: 'Phân loại',
      render: (_, record) => {
        return (
          <div>
            <Space>

              <div>
                {record.variants?.length}
              </div>
            </Space>
          </div>

        )
      }
    },

    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button type='link' onClick={e => navigate(`/product/edit/${record.id}`)}><EyeOutlined /></Button>
        </Space>
      ),
    },
  ];



  return (

    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      <Card style={{ width: "100%" }}>

        <Space direction="vertical" size={8} style={{ width: "100%" }} >
          <Search
            placeholder="Tên hoặc mã"
            onChange={e => setFilterValue("info", e.target.value)}
            style={{
              width: "100%",
            }}
            value={filter.info}
          />
          <Space size={16} >
            <div style={{ gap: 8 }}>
              <label>Kho</label>
              <Select defaultValue={"all"} value={filter.stock} style={{ width: 200 }} onChange={e => setFilterValue("stock", e)}>
                <Select.Option value="all">Tất cả</Select.Option>
                <Select.Option value="in_stock">Còn</Select.Option>
                <Select.Option value="out_of_stock">Hết</Select.Option>

              </Select>
            </div>
            <div>
              <label>Trạng thái</label>
              <Select defaultValue={"all"} value={filter.status} style={{ width: 200 }} onChange={e => setFilterValue("status", e)}>
                <Select.Option value="all">Tất cả</Select.Option>
                <Select.Option value="show">Đang hiển thị</Select.Option>
                <Select.Option value="hide">Đang ẩn</Select.Option>

              </Select>
            </div>

            <div>
              <label>Tag</label>
              <TagsPicker value={filter.tag} style={{ width: 200 }} onChange={e => setFilterValue("tag", e)} ></TagsPicker>

            </div>
            <div>
              <label>Danh mục</label>
              <CategoryPicker value={filter.category} style={{ width: 200 }} onChange={e => setFilterValue("category", e)} ></CategoryPicker>

            </div>

          </Space>





          <Flex justify='flex-end' style={{ width: "100%" }}>
            <Button type='primary' onClick={e => navigate("/product/add")} >Thêm mới</Button>
          </Flex>
        </Space>

      </Card>
      <Card>
        <Table columns={columns} dataSource={data} />
      </Card>
    </Space>

  )

}
export default ProductList;